;

// copy from  vue/src/shared/util.js
const camelizeRE = /-(\w)/g
function camelize(str){
  return str.replace(camelizeRE, (_, c) => c ? c.toUpperCase() : '')
}

// 用于生成 hbox, vbox 2个全局组件

[
  ['hbox', 'left', 'right', 'top', 'bottom', 'width'],
  ['vbox', 'top', 'bottom', 'left', 'right', 'height'],
].forEach(function([tagName, leftOrTop, rightOrBottom, topOrLeft, bottomOrRight, widthOrHeight]) {
  let propLeftOrTop = 'fix-' + leftOrTop
  let propRightOrBottom = 'fix-' + rightOrBottom
  Vue.component(tagName, {
    functional: true,
    props: [propLeftOrTop, propRightOrBottom],
    render: function(createElement, context) {
      let children = []
      let keyLeftOrTop = camelize(propLeftOrTop)
      let keyRightOrBottom = camelize(propRightOrBottom)
      if (context.props[keyLeftOrTop]) {
        children.push(createElement('div', {
          style: {
            position: 'absolute',
            [topOrLeft]: '0',
            [bottomOrRight]: '0',
            [leftOrTop]: '0',
            [widthOrHeight]: context.props[keyLeftOrTop],
          }
        }, context.slots()[leftOrTop]))
      }
      children.push(createElement('div', {
        style: {
          height: '100%',
        }
      }, context.slots().default))
      if (context.props[keyRightOrBottom]) {
        children.push(createElement('div', {
          style: {
            position: 'absolute',
            [topOrLeft]: '0',
            [bottomOrRight]: '0',
            [rightOrBottom]: '0',
            [widthOrHeight]: context.props[keyRightOrBottom],
          }
        }, context.slots()[rightOrBottom]))
      }
      return createElement('div', {
        style: {
          'height': '100%',
          ['padding-' + leftOrTop]: context.props[keyLeftOrTop],
          ['padding-' + rightOrBottom]: context.props[keyRightOrBottom],
          'position': 'relative',
          'box-sizing': 'border-box',
        },
        class: context.data.class
      }, children)
    },
  })
})



// WEBPACK FOOTER //
// ./src/commonplugin/common/hbox-vbox.js